module.exports = __webpack_public_path__ + "static/media/safespace.2714c4e3.jpg";